import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { STORAGE_KEYS } from '../config/storage-keys.config';
import { DateFormatService } from '../services/date-format/date-format.service';
import { StorageService } from '../services/storage/storage.service';

export function initializeDateFormat(): Promise<void> {
  const storage = inject(StorageService);
  const dateFormatService = inject(DateFormatService);
  const token = storage.getItem<string>(STORAGE_KEYS.AUTH_TOKEN);

  if (!token) {
    return Promise.resolve();
  }

  return firstValueFrom(dateFormatService.initialize());
}
